import { PlatformType } from '../../integrate/platform_type';
import { DEFAULT_PAST_ORDERS, TOTAL_ORDERS_TO_DISPLAY_TOGGLE } from '../setup/form/constants';

export interface MapState {
  enabled: boolean;
  pastOrdersEnabled: boolean;
  storeName: string;
  subject: string;
  message: string;
  signatureChanged: boolean;
  subjectChanged: boolean;
  bodyChanged: boolean;
  id: string;
  pastOrders: number;
  missingProduct: boolean;
  totalOrders: number;
  hasOrderLimitFeature: boolean;
  hasPostmanEditorFeature: boolean;
  hasPostmanDeliveryFeature: boolean;
  doneInstallation: boolean;
  platform: PlatformType;
};

export const initialMapState: MapState = {
  enabled: true,
  pastOrdersEnabled: true,
  storeName: '',
  subject: '',
  message: '',
  signatureChanged: false,
  subjectChanged: false,
  bodyChanged: false,
  id: '',
  pastOrders: DEFAULT_PAST_ORDERS,
  missingProduct: false,
  totalOrders: TOTAL_ORDERS_TO_DISPLAY_TOGGLE,
  hasOrderLimitFeature: false,
  hasPostmanEditorFeature: false,
  hasPostmanDeliveryFeature: false,
  doneInstallation: false,
  platform: PlatformType.Other,
};
